_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-card-detail-badge-view'
Dates = require 'app/scripts/lib/dates'
DateEditorView = require 'app/scripts/views/custom-field/date-editor-view'
moment = require 'moment'
PopOver = require 'app/scripts/views/lib/pop-over'
t = require('app/scripts/views/internal/teacup-with-helpers')('custom_fields')
Util = require 'app/scripts/lib/util'

module.exports = class CustomFieldDateCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ icon, name, text, editable, color } = {}) ->
    t.h3 '.card-detail-item-header', { title: name }, ->
      t.icon icon, { class: "mod-quiet" }
      t.text name

    if editable
      t.a '.custom-field-detail-badge.is-clickable.js-custom-field-detail-badge' + color, { href: '#', title: text }, ->
        if text
          t.text text
        else
          t.span '.icon-sm.icon-add'
          t.format 'add date'
    else
      t.span '.custom-field-detail-badge' + color, { title: text }, ->
        t.text text

  getBadgeText: ->
    if date = @customFieldItem?.get('value')?.date
      moment(new Date(date)).calendar()
    else
      ''

  events:
    'click .js-custom-field-detail-badge': 'editCustomFieldBadge'

  editCustomFieldBadge: (e) ->
    Util.stop(e)
    @track()

    PopOver.toggle
      elem: @$(e.target).closest('.js-custom-field-detail-badge')
      view: DateEditorView
      options: { @model, @modelCache, customFieldItem: @customFieldItem, customField: @customField }
